export default __webpack_public_path__ + "static/media/999.4a11851c.svg";